var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ContentPageContainer',{attrs:{"isIOSApp":_vm.isFromIOSAPP}},[_c('AccountInformationRegistContent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }